var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendanceList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3733",
    "data-name": "Caminho 3733",
    d: "M23,1.5a.938.938,0,0,1,.7.3.938.938,0,0,1,.3.7v19a1.025,1.025,0,0,1-1,1H7a1.025,1.025,0,0,1-1-1V18H1a.938.938,0,0,1-.7-.3A.938.938,0,0,1,0,17V7a.938.938,0,0,1,.3-.7A.918.918,0,0,1,1,6H6V2.5a.938.938,0,0,1,.3-.7A.938.938,0,0,1,7,1.5ZM6,13.28l1.42,2.66H9.56L7.18,12.07l2.34-3.8H7.46l-1.3,2.4-.05.08-.04.09L5.43,9.56,4.77,8.27H2.59l2.27,3.82L2.38,15.94H4.54ZM14.25,21V18H7.5v3Zm0-4.5V12.75H12V16.5Zm0-5.25V7.5H12v3.75Zm0-5.25V3H7.5V6ZM22.5,21V18H15.75v3Zm0-4.5V12.75H15.75V16.5Zm0-5.25V7.5H15.75v3.75ZM22.5,6V3H15.75V6Z",
    transform: "translate(0 -1.5)",
    fill: "#667085",
    stroke: "#000",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceList);
export default __webpack_public_path__ + "static/media/attendance_list.4fefda05f0da1c16594a9d115f713e7c.svg";
export { ForwardRef as ReactComponent };